import axios, { AxiosPromise } from 'axios'
import { RastreioCancerInput } from 'graphql/types.generated'
import {
  ImpressaoRequisicaoCitopatologicoComDadosInput,
  ImpressaoRequisicaoExamesSaudeMulherInput,
  ImpressaoSolicitacaoExamesInput,
} from 'view/atendimentos/detail/soap/plano/exames/model-solicitacaoExames'

interface ImpressaoSolicitacaoExameInputModel {
  solicitacoes: ImpressaoSolicitacaoExamesInput[]
  citopatologicoPreenchido: RastreioCancerInput[]
  mamografiaPreenchido: RastreioCancerInput[]
}

export class ImpressaoSolicitacaoExames {
  imprimirSolicitacaoExames(input: ImpressaoSolicitacaoExameInputModel): AxiosPromise<Blob> {
    return axios.post('/api/atendimento/imprimirSolicitacaoExames', input, { responseType: 'blob' })
  }

  imprimirRequisicaoMamografia(input: ImpressaoRequisicaoExamesSaudeMulherInput): AxiosPromise<Blob> {
    return axios.post('/api/atendimento/imprimirSolicitacaoExames/imprimirRequisicaoMamografia', input, {
      responseType: 'blob',
    })
  }

  imprimirRequisicaoCitopatologico(input: ImpressaoRequisicaoExamesSaudeMulherInput): AxiosPromise<Blob> {
    return axios.post('/api/atendimento/imprimirSolicitacaoExames/imprimirRequisicaoCitopatologico', input, {
      responseType: 'blob',
    })
  }

  imprimirRequisicaoCitopatologicoComDados(input: ImpressaoRequisicaoCitopatologicoComDadosInput): AxiosPromise<Blob> {
    return axios.post('/api/atendimento/imprimirSolicitacaoExames/imprimirRequisicaoCitopatologicoComDados', input, {
      responseType: 'blob',
    })
  }
}
